const getAllBrandKeys = () => 
  // Select all sections with data-brand-key in <main>
  [...document.querySelectorAll('main section[data-brand-key]')]
    // Extract data-brand-key value from each section
    .map(section => section.getAttribute('data-brand-key')?.toLowerCase());

const getBrandKeyFromUrl = () => {
  // Create a URL object from the current page URL
  const url = new URL(window.location.href);

  // Get the pathname and split it into segments
  const segments = url.pathname.split('/')?.filter(segment => segment.length > 0) || [];

  // Get the last segment (should be brand-key) or null
  return segments.pop()?.toLowerCase() || null;
};

const getBrandSelector = () => document.getElementById('brand-archive-selector');

const showBrandSelector = (selectedBrandKey, brandKeys) => {
  // Check if the selector is present on the page (only in them editor or preview mode)
  const brandSelector = getBrandSelector();
  if (brandSelector) {
    // If so, creates and adds the options
    brandKeys.forEach(brandKey => {
      const option = document.createElement('option');
      option.value = brandKey;
      option.text = brandKey;
      option.selected = brandKey === selectedBrandKey;
      brandSelector.appendChild(option);
    });

    // Add change event listener
    brandSelector.addEventListener('change', ({target}) => {
      selectBrandArchive(target.value);
    });

    // Add the select element to the archive page
    const mainElement = document.querySelector('main');
    mainElement.insertBefore(brandSelector, mainElement.firstChild);

    // By default selects the first brand
    selectBrandArchive(brandKeys[0]);
  }
};

const selectBrandArchive = (brandKey) => {
  // Makes sure all brands are hidden
  document.querySelectorAll('main section[data-brand-key]')
    .forEach(section => section.classList.remove('show'));

  // Selects/shows the section matching the brand key
  const selectedSection = document.querySelector(`main section[data-brand-key="${brandKey}"]`);
  if (selectedSection) {
    selectedSection.classList.add('show');
  }
};

/**
 * MAIN: runs on page load once the dom is ready
 */
document.addEventListener('DOMContentLoaded', function() {
  const brandKey = getBrandKeyFromUrl();
  const allBrandKeys = getAllBrandKeys();

  // Create the brand selector dropdown (this only happens withing the theme editor)
  showBrandSelector(brandKey, allBrandKeys);

  // Check if the brand-key from the URL is part of the brands in the archive page
  if (allBrandKeys.includes(brandKey)) {
    // If so, displays it
    selectBrandArchive(brandKey);
  } else {
    // If not, assumes the URL is malformed and redirect the client back to the landing of archive
    if (!getBrandSelector()) {
      // If not inside the theme editor
      window.location.href = '/pages/archive';
    }
  }
});